@if (isLoading) {
  <div class='loading-spinner' style="position:fixed; z-index: 9;"></div>
}
<div class="top-title-main" [style]="{'opacity': (isLoading ? 0.3 : 1)}">
  <div class="divider">
    <div class="pageTitle left">Portfolios</div>
  </div>
  <div class="top-action-btn-content">
    <button (click)="createRebalance()" [disabled]="disableActionBtn" class="btn-large-primary rebalanceDisable relative">Rebalance
      @if (disableActionBtn) {
        <div
          style="position:absolute;left:0;top:0;z-index: 9999; width: 104px; height: 32px"
          tooltip [tooltipPosition]="'right'"
        [tooltipTitle]="'Rebalance the items selected below'"></div>
      }
    </button>
    <button class="btn-large-secondary" (click)="createNewPortfolio()">Create</button>
    <button style="position: relative;" [matMenuTriggerFor]="subMenu2" class="btn-large-secondary btnWithArrow">Import<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>
    <mat-menu #subMenu2="matMenu" class="nav__items_action_btn" yPosition="below">
      <button class="nav__item_action_btn" mat-menu-item (click)="showImportModelAndCategoryDialog()">Model Labels and Gains</button>
      <button class="nav__item_action_btn" mat-menu-item (click)="showImportPortfolioNameDialog()">Portfolio Names</button>
    </mat-menu>
  </button>
  <button
    [matMenuTriggerFor]="subMenu1"
    [disabled]="disableActionBtn"
    class="btn-large-secondary btnWithArrow relative">
    Actions <i class="material-icons md-24 md-align dropdown-arrow-align">arrow_drop_down</i>

    @if (disableActionBtn) {
      <div
        style="position:absolute;left:0;top:0;z-index: 9999; width: 104px; height: 32px"
        tooltip [tooltipPosition]="'right'"
      [tooltipTitle]="'Activate &quot;Actions&quot; by first selecting the checkboxes for the portfolios below'"></div>
    }

    <mat-menu #subMenu1="matMenu" class="nav__items_action_btn" yPosition="below">
      <button class="nav__item_action_btn" mat-menu-item (click)="editMultiplePortfoliosDialog()">Edit</button>
      <button class="nav__item_action_btn" mat-menu-item (click)="deletePortfolioDialog()">Delete</button>
      <button class="nav__item_action_btn" mat-menu-item [matMenuTriggerFor]="export">Export</button>
    </mat-menu>

    <mat-menu #export="matMenu" class="nav__items_action_btn isSubMenu">
      <button class="nav__item_action_btn" mat-menu-item (click)="exportModelAndCategory()">
        Model Labels and Gains
      </button>
      <button class="nav__item_action_btn" mat-menu-item (click)="exportPortfolioNotes()">Notes</button>
      <button class="nav__item_action_btn" mat-menu-item (click)="exportPortfolioRestrictions()">Restrictions</button>
      <button class="nav__item_action_btn" mat-menu-item (click)="exportDetails()">All portfolio details</button>
    </mat-menu>
  </button>
  <button (click)="finmasonCall()" [disabled]="disableFinmasonBtn" class="btn-large-secondary relative">
    Analyze in FinMason
    <img src="../../assets/images/external_black.png" class="external_icon" style="margin-left: 4px;width:12px;" [style]="{'opacity': (disableFinmasonBtn ? 0.45 : 1)}">
    @if (disableFinmasonBtn) {
      <div style="position: absolute; width: 100%; height: 100%; top: 0px; left: 0px; cursor: pointer;" calltoaction
        calltoactionUsesHover="true"
        calltoactionPosition="bottom"
      [calltoactionTemplate]="finmasonButtonSelectTemplateRef"></div>
    }
  </button>
  <button style="position: relative;" [matMenuTriggerFor]="subMenuSAC" class="btn-large-secondary btnWithArrow"
    >Go to SAC<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>
    <mat-menu #subMenuSAC="matMenu" class="nav__items_action_btn" yPosition="below">
      <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_BAL','_blank')">Balances</button>
      <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_POS','_blank')">Positions</button>
      <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_TRAN','_blank')">Transactions</button>
      <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_COST','_blank')">Cost Basis</button>
      <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_RMD','_blank')">RMD</button>
    </mat-menu>
  </button>
</div>
</div>

<ng-template #finmasonButtonSelectTemplateRef >
  <div>Select a portfolio for analysis. The portfolio must have at least one Schwab account assigned to it.</div>
</ng-template>

<ng-template #noOptionsTemplate >
  <div style='margin-bottom: 10px !important;'>No labels created. Create custom portfolio<br/>labels in iRebal settings.</div><a (click)='pls.openGlobalSettings()'>Go to Settings</a>
</ng-template>

<irb-filter-chips [filterData]="_filterChipModel" [dataMap]="filterDisplayNamesData" (removeFilterItem)="onRemoveFilterItem($event)" [context]="loadingOverlayComponentParams"></irb-filter-chips>
@if (!isUiTest && globalSettingsReceived) {
  <irb-inventory-grid
    [style]="{'opacity': (isLoading ? 0.3 : 1)}"
    id="portfolios-component-grid" class="show-grid-toolbar-buttons"
    [style.minHeight]="'600px'"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    [frameworkComponents]="frameworkComponents"
    [sideBar]="sideBar"
    [footerContent]="footerContent"
    [loadingOverlayComponent]="'customLoadingOverlay'"
    [loadingOverlayComponentParams]="loadingOverlayComponentParams"
    [componentName]="componentName"
    [contextMenuItems]="getContextMenuItems()"
    [noRowsOverlayComponent]="'customNoRowOverlay'"
    [noRowsOverlayComponentParams]="loadingOverlayComponentParams"
    [showFiltersColumns]="true"
    [columnLimits]="columnLimits"
  ></irb-inventory-grid>
}
